import React from "react";
import "./About.css"; // Import the CSS file
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation("global");
  const speciesList = [
    {
      id: 1,
      name: "Acrostichum aureum",
      commonName: "Golden Leather Fern",
      banglaName: "হুদো / টাইগার ফার্ন",
      img: "AA.jpg",
    },
    {
      id: 2,
      name: "Aegiceras corniculatum",
      commonName: "River Mangrove",
      banglaName: "খুলশি",
      img: "AC.jpg",
    },
    {
      id: 3,
      name: "Aglaia cucullata",
      commonName: "Cowl Aglaia",
      banglaName: "আমুর",
      img: "AC2.jpg",
    },
    {
      id: 4,
      name: "Avicennia alba",
      commonName: "White Mangrove",
      banglaName: "মরিচা বাইন",
      img: "AA2.jpg",
    },
    {
      id: 5,
      name: "Avicennia marina",
      commonName: "Grey Mangrove",
      banglaName: "সাদা বাইন",
      img: "AM.jpg",
    },
    {
      id: 6,
      name: "Barringtonia acutangula",
      commonName: "Freshwater Mangrove",
      banglaName: "হিজল",
      img: "BA.jpg",
    },
    {
      id: 7,
      name: "Brownlowia tersa",
      commonName: "Brownlowia",
      banglaName: "লতা সুন্দরী",
      img: "BT.jpg",
    },
    {
      id: 8,
      name: "Bruguiera gymnorhiza",
      commonName: "Large-leafed Orange Mangrove",
      banglaName: "লাল কাঁকড়া",
      img: "BG.jpg",
    },
    {
      id: 9,
      name: "Bruguiera sexangula",
      commonName: "Six-angled Mangrove",
      banglaName: "সাদা কাঁকড়া",
      img: "BS.jpg",
    },
    {
      id: 10,
      name: "Calophyllum inophyllum",
      commonName: "Alexandrian Laurel",
      banglaName: "সুলতান চাঁপা",
      img: "CI.jpg",
    },
    {
      id: 11,
      name: "Casuarina equisetifolia",
      commonName: "Horsetail Tree",
      banglaName: "বিলাতি ঝাউ",
      img: "CE.jpg",
    },
    {
      id: 12,
      name: "Cerbera odollam",
      commonName: "Suicide Tree",
      banglaName: "ডাবুর",
      img: "CO.jpg",
    },
    {
      id: 13,
      name: "Ceriops decandra",
      commonName: "Many-flowered Mangrove",
      banglaName: "গরান",
      img: "CD.jpg",
    },
    {
      id: 14,
      name: "Cynodon dactylon",
      commonName: "Bermuda Grass",
      banglaName: "দূর্বা",
      img: "CD2.jpg",
    },
    {
      id: 15,
      name: "Cynometra ramiflora",
      commonName: "Common Wild Mangrove",
      banglaName: "সিংড়া",
      img: "CR.jpg",
    },
    {
      id: 16,
      name: "Dalbergia spinosa",
      commonName: "Spiny-leaved Dalbergia",
      banglaName: "কাটা চিটকি",
      img: "DS.jpg",
    },
    {
      id: 17,
      name: "Derris scandens",
      commonName: "Climbing Derris",
      banglaName: "আমকুরচি / কালি লতা",
      img: "DS2.jpg",
    },
    {
      id: 18,
      name: "Derris trifoliata",
      commonName: "Three-leaved Derris",
      banglaName: "পান লতা",
      img: "DT.jpg",
    },
    {
      id: 19,
      name: "Exocearia agalocha",
      commonName: "Blind-your-eye Mangrove",
      banglaName: "গেওয়া",
      img: "EA.jpg",
    },
    {
      id: 20,
      name: "Heriteria fomes",
      commonName: "Sundari Tree",
      banglaName: "সুন্দরী গাছ",
      img: "HF.jpg",
    },
    {
      id: 21,
      name: "Hibiscus tiliaceus",
      commonName: "Sea Hibiscus",
      banglaName: "সমুদ্র জবা",
      img: "HT.jpg",
    },
    {
      id: 22,
      name: "Imperata cylindrica",
      commonName: "Cogon Grass",
      banglaName: "উলু ঘাস",
      img: "IC.jpg",
    },
    {
      id: 23,
      name: "Kandelia candel",
      commonName: "Candelabra Mangrove",
      banglaName: "ভাতকাঠি",
      img: "KC.jpg",
    },
    {
      id: 24,
      name: "Lumnitzera racemosa",
      commonName: "Black Mangrove",
      banglaName: "কিরপা",
      img: "LR.jpg",
    },
    {
      id: 25,
      name: "Nypa fruticans",
      commonName: "Nipa Palm",
      banglaName: "গোলপাতা",
      img: "NF.jpg",
    },
    {
      id: 26,
      name: "Pandanus tectorius",
      commonName: "Screw Pine",
      banglaName: "কেয়া / কেতকি",
      img: "PT.jpg",
    },
    {
      id: 27,
      name: "Phoenix paludosa",
      commonName: "Mangrove Date Palm",
      banglaName: "হেতাল",
      img: "PP.jpg",
    },
    {
      id: 28,
      name: "Pongamia pinnata",
      commonName: "Indian Beech",
      banglaName: "করচ",
      img: "PP.jpg",
    },
    {
      id: 29,
      name: "Rhizophora apiculata",
      commonName: "Tall-stilt Mangrove",
      banglaName: "গর্জন",
      img: "RA.jpg",
    },
    {
      id: 30,
      name: "Rhizophora mucronata",
      commonName: "Red Mangrove",
      banglaName: "ঝানা গর্জন",
      img: "RM.jpg",
    },
    {
      id: 31,
      name: "Sarcolobus globosus",
      commonName: "Globe Sarcolobus",
      banglaName: "করপুলা / বাওয়ালি-লতা",
      img: "SG.jpg",
    },
    {
      id: 32,
      name: "Shirakiopsis indica",
      commonName: "Chinese Tallow Tree",
      banglaName: "বাটুল",
      img: "SI.jpg",
    },
    {
      id: 33,
      name: "Tamarix indica",
      commonName: "Indian Tamarisk",
      banglaName: "নোনা ঝাঁও",
      img: "TI.jpg",
    },
    {
      id: 34,
      name: "Terminalia catappa",
      commonName: "Tropical Almond",
      banglaName: "কাঠ বাদাম",
      img: "TC.jpg",
    },
    {
      id: 35,
      name: "Xylocarpus granatum",
      commonName: "Cannonball Mangrove",
      banglaName: "ধুন্দল",
      img: "XG.jpg",
    },
    {
      id: 36,
      name: "Xylocarpus moluccensis",
      commonName: "Cedar Mangrove",
      banglaName: "পশুর",
      img: "XM.jpg",
    },
  ];
  return (
    <div className="about-us">
      <h1>About Sundori</h1>
      <p>{t("about.main")}</p>
      <h2>Supported Species</h2>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Common Name</th>
            <th>Bangla Name</th>
          </tr>
        </thead>
        <tbody>
          {speciesList.map((species) => (
            <tr style={{ gap: "10px" }} key={species.id}>
              <td className="about-td">{species.id}</td>
              <td className="about-td">{species.name}</td>
              <td
                className="
                about-td"
              >
                {species.commonName}
              </td>
              <td
                className="
                about-td"
              >
                {species.banglaName}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default About; // Export the About component
